<template>
  <ValidationObserver ref="observer" class="transition duration-500 ease-in-out transform w-full"
                      style="transition: all 1s !important"
                      tag="form" @submit.prevent="submit()">
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Course Name</label>
            <validation-provider v-slot="{ errors }" :rules="{
              required: true,

            }">
              <input id="coursename" v-model="formValues.courseName" :disabled="formValues.isAccrediting" class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                  " name placeholder="coursename"
                     type="text"/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Course Code<span style="font-weight: lighter">(To be filled by Accreditors)</span>)</label>

            <input id="courseCode" v-model="formValues.courseCode" :disabled="true" class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                  " name placeholder="Course Code"
                   type="text"/>

          </div>

          <div class="w-full md:w-1/2 px-3 pt-3 mb-6 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Continuing Education Unit(CEU)</label>
            <validation-provider v-slot="{ errors }" rules="required|min_value:0|max_value:15">
              <input v-model="formValues.continualEducationUnit" :disabled="formValues.isAccrediting" class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                  "
                     name placeholder="CEU (accepts only numeric values)" type="number"/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 pt-3 mb-6 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Course Level</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select v-model="formValues.courseLevelId" :clearable="clearable" :disabled="formValues.isAccrediting"
                        :elevation="1"
                        :items="COURSE_LEVELS" :loading="courseLevelLoading" :searchable="searchable" dense
                        item-text="name"
                        item-value="id" label="course levels" solo></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 pt-3 mb-6 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Course Duration</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <input v-model="formValues.courseDuration" class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                  " name
                     placeholder="(accepts only number of days)" type="number"/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Course Owner</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete v-model="formValues.courseOwnerId" :clearable="clearable"
                              :disabled="(formValues?.courseOwnerId ?? false) || (formValues.isAccrediting)" :elevation="1"
                              :items="COURSE_OWNER" :loading="courseOwnerLoading" :searchable="searchable" dense
                              item-text="trainingCenterName"
                              item-value="id" label="course owners"
                              solo
              ></v-autocomplete>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Target Audience:
            </label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete v-model="formValues.targetAudienceIds" :clearable="clearable"
                              :disabled="formValues.isAccrediting" :items="TARGET_AUDIENCE"
                              :loading="targeAudLoading" :searchable="searchable" chips class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none
                    focus:shadow-outline
                  " deletable-chips
                              hint="select target audiences"
                              item-text="name" item-value="id" label="target audiences" multiple
                              persistent-hint>
              </v-autocomplete>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>

          <div v-if="!formValues.isAccrediting" class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Accredited By<span style="font-weight: lighter">(To be filled by Accreditors)</span>:
            </label>
            <v-select v-model="formValues.courseAccreditorId" :clearable="clearable"
                      :disabled="formValues?.courseAccreditorId ?? true"
                      :elevation="1" :items="ACCREDITED_BY" :loading="accreditorsLoading" :searchable="searchable" dense
                      item-text="accreditorName" item-value="id" solo></v-select>
            <br/>
          </div>

          <div v-else class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Accredited By<span style="font-weight: lighter">(To be filled by Accreditors)</span>:
            </label>
            <validation-provider v-slot="{ errors }" rules="required">

              <v-select v-model="formValues.courseAccreditorId" :clearable="clearable" :elevation="1"
                        :items="ACCREDITED_BY" :loading="accreditorsLoading" :searchable="searchable" dense
                        item-text="accreditorName"
                        :disabled="formValues?.courseAccreditorId ?? false"
                        item-value="id" solo></v-select>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Date of Accreditation <span style="font-weight: lighter">(To be filled by Accreditors)</span>:
            </label>

            <v-menu ref="menu" v-model="startMenu" :close-on-content-click="false" max-width="290px"
                    min-width="290px"
                    offset-y transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="formValues.courseAccreditationDate" :disabled="true"
                              label="date of accreditation"
                              persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker
                  ref="courseAccreditationDate" v-model="formValues.courseAccreditationDate"
                  :max="date" no-title scrollable
                  @input="startMenu = false"
              ></v-date-picker>
            </v-menu>
            <span class="ml-6 ">( GC ) {{ convertEG(formValues.courseAccreditationDate) }}</span>

          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Passing Score</label>
            <validation-provider v-slot="{ errors }" rules="required|min_value:0|max_value:100">
              <input id="passingscore" v-model="formValues.passingScore" :disabled="formValues.isAccrediting" class="
                    shadow
                    appearance-none
                    border
                    rounded
                    w-full
                    py-2
                    px-3
                    text-gray-700
                    leading-tight
                    focus:outline-none focus:shadow-outline
                  " max="100" min="0"
                     name placeholder="passing score" type="number"/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <br/>

        </div>

        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full">
            <button class="
                  float-right
                  shadow
                  bg-teal-600
                  hover:bg-teal-600
                  focus:shadow-outline focus:outline-none
                  text-white
                  font-bold
                  py-2
                  px-4
                  rounded
                " type="button"
                    @click="showConfirmation(formValues.editMode, formValues.isAccrediting)"
            >
              {{
                formValues.editMode ? (formValues.isAccrediting ? "Accredit Course" : "Update Course") : "Add Course"
              }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>

      </v-card>
      <confirmationModal
          v-if="confirmation"
          @confirmed="submit"
          :title="title"
          @close="confirmation = false"
          @openDialog="true"
      >
      </confirmationModal>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {max_value, min_value, regex, required} from "vee-validate/dist/rules";
import ethiopic from "ethiopic-calendar";
import {getCourseLevel, getHealthProfessions, getUser} from "@/utils/helper";
import {AccreditorService} from "../Accreditors/accreditor.service";
import {TrainingCenterService} from "../TrainingCenter/training_center.service";
import confirmationModal from "../../common/confirmation-modal.vue";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("regex", {
  ...regex,
  message: "Name should contain only letters",
});
extend("min_value", {
  ...min_value,
  message: "Invalid Value",
});
extend("max_value", {
  ...max_value,
  message: "Invalid Value",
});
export default {
  props: ["course", "changeTCourseUsedNo", "changeCourseOwnerNo"],
  components: {
    confirmationModal,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        courseName: null,
        courseCode: null,
        continualEducationUnit: null,
        courseDuration: null,
        courseLevelId: null,
        courseOwnerId: null,
        courseAccreditorId: null,
        courseAccreditationDate: null,
        targetAudienceIds: [],
        passingScore: null,
        isAccredited: false,
        editMode: false,
      },
      showProgress: false,
      COURSE_LEVELS: [],
      COURSE_OWNER: [],
      ACCREDITED_BY: [],
      TARGET_AUDIENCE: [],
      TRAINING_COURSE_USED: [],
      showAccreditationOptions: false,
      showOwnerName: false,
      startMenu: false,
      mutableTCourseUsedNo: this.changeTCourseUsedNo,
      mutableCourseOwnerNo: this.changeCourseOwnerNo,
      showTrainingCourseUsed: false,
      date: new Date().toISOString().substr(0, 10),
      etDate: null,
      clearable: true,
      searchable: true,
      courseLevelLoading: false,
      courseOwnerLoading: false,
      accreditorsLoading: false,
      targeAudLoading: false,

      confirmation: false,
      title:''
    };
  },
  beforeMount() {
    const user = getUser();
    const date = new Date().toISOString().substr(0, 10);
    this.etDate = this.convertGE(date);
    this.formValues.courseAccreditorId = this.formValues.courseAccreditorId ?? user.data.accreditorId;
  },
  async created() {
    const user = getUser();
    const date = new Date().toISOString().substr(0, 10);
    this.etDate = this.convertGE(date);

    if (this.course != null) {
      this.formValues = this.course;
      let targetAudienceIds = [];
      this.course.courses_target_audiences.forEach((targetAudience) => {
        targetAudienceIds.push(targetAudience.targetAudienceId);
      });
      this.formValues.targetAudienceIds = targetAudienceIds;
      if (this.formValues.isAccrediting) {
        // this.formValues.courseAccreditorId = user.data.userFacility?.id;
        this.formValues.courseAccreditor = user.data.userFacility;
        this.formValues.courseAccreditationDate = this.date;
        this.generateCourseCode();
      }
      this.formValues.editMode = true;
    }
    await this.initateLookups();

  },
  methods: {
    async showConfirmation(editMode, isAcc) {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();

      this.confirmation = true;
      this.title = editMode? (isAcc ? "Accredit Course" : "Update Course")  : "Add Course"
    },
    generateCourseCode() {
      const courseLevel = this.formValues.courseLevel?.name.substring(0, 1);
      const accreditor = this.formValues.courseAccreditor ? this.formValues.courseAccreditor.accreditorName ? this.formValues.courseAccreditor.accreditorName.substring(0, 1) : this.formValues.courseAccreditor.name ? this.formValues.courseAccreditor.name.substring(0, 1) : this.formValues.courseAccreditor.substring(0, 1) : null;
      const accreditationDate = this.formValues.courseAccreditationDate;
      const accreditationString = accreditationDate.toString().split('-');
      const microsecond = new Date().getMilliseconds();
      const year = accreditationString[0];
      const month = accreditationString[1];
      const serial = this.generateFourDigitSerial(this.formValues.courseAccreditorId ? this.formValues.courseAccreditorId : 1);
      const generatedCode = courseLevel + accreditor + year + month + microsecond + serial;
      // const generatedCode = year + month + microsecond + serial;
      this.formValues.courseCode = generatedCode;
      return generatedCode;
    },

    generateFourDigitSerial(number) {
      const newNumber = number + 1;
      const numberString = newNumber.toString();

      if (numberString.length === 4) {
        return numberString;
      }

      const leadingZeros = '0'.repeat(4 - numberString.length);
      return leadingZeros + numberString;
    },

    async initateLookups() {
      this.courseLevelLoading = true;
      this.courseOwnerLoading = true;
      this.accreditorsLoading = true;
      this.targeAudLoading = true;
      this.COURSE_LEVELS = await getCourseLevel();
      this.courseLevelLoading = false;
      const accreditorsResp = await AccreditorService.getAllAccreditorsList();
      this.ACCREDITED_BY = accreditorsResp.data.rows.filter((data) => {
        return data.isActive == true;
      });
      this.accreditorsLoading = false;
      const cpdResponse = await TrainingCenterService.getAllTrainingCenters();

      const user = getUser();
      if(!this.formValues.courseOwnerId && user?.data?.cpdProviderId){
        this.COURSE_OWNER = cpdResponse.data.rows.filter((data) => {
          return (data.id == user?.data?.cpdProviderId || data.id == 36) && data.isActive == true;
        });
      }
      else{
        this.COURSE_OWNER = cpdResponse.data.rows.filter((data) => {
          return data.isActive == true;
        });
      }
      this.courseOwnerLoading = false;
      const tAudienceResp = await getHealthProfessions();
      this.TARGET_AUDIENCE = tAudienceResp.rows.filter((data) => {
        return data.isActive == true;
      });
      this.targeAudLoading = false;
    },
    convertGE(val) {
      if (!val) return val;
      const [year, month, day] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
        return etDate.year.toString().padStart(4, "0");
      } else {
        let etDate = ethiopic.ge(year, month || 1, day || 1);
        return (
            etDate.year.toString().padStart(4, "0") +
            "-" +
            etDate.month.toString().padStart(2, "0") +
            "-" +
            etDate.day.toString().padStart(2, "0")
        );
      }
    },
    convertEG(val) {
      if (!val) return val;
      const [etYear, etMonth, etDay] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let gDate = ethiopic.eg(etYear, etMonth || 6, etDay || 1); // so it will be the same year in both directions
        return gDate.year.toString().padStart(4, "0");
      } else {
        let gDate = ethiopic.eg(etYear, etMonth || 1, etDay || 1);
        return (
            gDate.year.toString().padStart(4, "0") +
            "-" +
            gDate.month.toString().padStart(2, "0") +
            "-" +
            gDate.day.toString().padStart(2, "0")
        );
      }
    },
    async submit() {
      this.formValues.isAccrediting == true ? this.formValues.isAccredited = true : this.formValues.isAccredited = false;
      this.$emit("registerOrUpdateCourse", this.formValues);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
